// Important: this file is generated from the 'build' script and should not be
// edited directly
export var version = '3.16.2';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/autolinker/dist/es2015/version.js
// module id = null
// module chunks = 